'use client'

import { SessionProvider, useSession } from 'next-auth/react'
import { ToastProvider } from '@/components/ui/toast'
import { CommandPalette } from '@/components/CommandPalette'
import { AIProvider } from '@/context/AIContext'
import { AIManager } from '@/components/ai/AIManager'
import { DemoStateWatcher } from '@/components/layout/DemoStateWatcher'
import { isReviewerOnly } from '@/lib/roles'
import { CountryProvider, ViewScope } from '@/lib/country-context'

/** The command palette is not mounted for a reviewer-only session (plan 04 WP-REV-07). */
function ShellCommandPalette() {
  const { data: session } = useSession()
  if (isReviewerOnly(session?.roles)) return null
  return <CommandPalette />
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider
      basePath={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/api/auth`}
      // Refetch session every 4 minutes to keep tokens fresh
      // This triggers the JWT callback which handles token refresh
      refetchInterval={4 * 60}
      // Also refetch when user returns to the tab
      refetchOnWindowFocus={true}
    >
      {/* Per-user Country / Industry view; ViewScope remounts the page when it changes. */}
      <CountryProvider>
        <AIProvider>
          <ViewScope>{children}</ViewScope>
          <ToastProvider />
          <DemoStateWatcher />
          <ShellCommandPalette />
          <AIManager />
        </AIProvider>
      </CountryProvider>
    </SessionProvider>
  )
}
